import { Base } from './_base';
import { merge_by_template } from '@shared/helpers/collections';

export class PostbackFrontend extends Base {
  constructor(item) {
    super(item);

    this.data = merge_by_template(this.data, {
      params: {
        url: '',
        data: ''
      },
      options: {
        next: null
      }
    });
  }
}
